// extracted by mini-css-extract-plugin
export default {"PopOver":"GitButton_PopOver__LXSoC","MenuItem":"GitButton_MenuItem__AVzoD"};